"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseView_1 = require("@/views/BaseView");
var vue_property_decorator_1 = require("vue-property-decorator");
var ViewWrapper_vue_1 = __importDefault(require("@/components/view-wrapper/ViewWrapper.vue"));
var dayjs_1 = __importDefault(require("dayjs"));
var TripPilgrimCardResult_vue_1 = __importDefault(require("@/components/trip/pilgrim-card-result/TripPilgrimCardResult.vue"));
var SearchWrapper_vue_1 = __importDefault(require("@/components/search-wrapper/SearchWrapper.vue"));
var parameters_1 = __importDefault(require("@/config/parameters"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
var SearchPilgrimTrips = /** @class */ (function (_super) {
    __extends(SearchPilgrimTrips, _super);
    function SearchPilgrimTrips() {
        var _this = _super.call(this) || this;
        dayjs_1.default.extend(utc_1.default);
        dayjs_1.default.extend(customParseFormat_1.default);
        _this.page = 1;
        _this.total = 0;
        _this.pilgrimTrips = [];
        _this.searchParameters = {
            search_text: '',
            date_from: null,
            date_to: null,
            owner_country_id: null,
            partnership_id: null
        };
        _this.selectCountriesOptions = [];
        return _this;
    }
    SearchPilgrimTrips.prototype.mounted = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.$getPartnershipDataService.request(this.$route.params.partnershipSlug)];
                    case 1:
                        _a.partnership = _b.sent();
                        this.searchParameters.partnership_id = this.partnership.id;
                        this.fetchCountryOptions();
                        this.search();
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchPilgrimTrips.prototype.changePage = function (page) {
        this.page = page;
        this.search();
        this.$scrollToTop();
    };
    SearchPilgrimTrips.prototype.search = function () {
        var _this = this;
        if (this.searchParameters.date_from) {
            this.searchParameters.date_from = this.formatDate(this.searchParameters.date_from);
        }
        if (this.searchParameters.date_to) {
            this.searchParameters.date_to = this.formatDate(this.searchParameters.date_to);
        }
        this.emitInteractionEvent();
        this.loader = true;
        this.$searchPilgrimsTripsService.request(this.searchParameters, this.page).then(function (response) {
            _this.total = response.total;
            _this.pilgrimTrips = response.list;
            _this.loader = false;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    SearchPilgrimTrips.prototype.formatDate = function (date) {
        return dayjs_1.default(date).format('YYYY-MM-DD HH:mm:ss');
    };
    SearchPilgrimTrips.prototype.resetSearchParameters = function () {
        this.searchParameters.owner_country_id = null;
        this.searchParameters.date_from = null;
        this.searchParameters.date_to = null;
        this.searchParameters.search_text = '';
        this.page = 1;
        this.search();
    };
    SearchPilgrimTrips.prototype.fetchCountryOptions = function () {
        var _this = this;
        this.selectCountriesOptions.push({
            value: null,
            text: this.$t('common.noSelected')
        });
        this.$getAllCountriesAvailableService.request().then(function (response) {
            response.forEach(function (country) {
                _this.selectCountriesOptions.push({
                    value: country.id,
                    text: country.name
                });
            });
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    SearchPilgrimTrips.prototype.changeCriteria = function () {
        this.page = 1;
        this.search();
    };
    SearchPilgrimTrips.prototype.emitInteractionEvent = function () {
        if (this.searchParameters.search_text.length === 0) {
            return;
        }
        var interaction = {
            locale: this.$i18n.locale,
            partnership_slug: this.$route.params.partnershipSlug,
            client_utc_date: dayjs_1.default.utc().format('YYYY-MM-DD HH:mm:ss'),
            input_text_id: this.$refs.inputSearchTripPilgrim.$el.id,
            value: this.searchParameters.search_text,
            type: parameters_1.default.clientTracking.interactionTypes.searchText
        };
        this.$root.$emit('USER_INTERACTION', interaction);
    };
    SearchPilgrimTrips = __decorate([
        vue_property_decorator_1.Component({
            name: 'SearchPilgrimTrips',
            components: {
                ViewWrapper: ViewWrapper_vue_1.default,
                TripPilgrimCardResult: TripPilgrimCardResult_vue_1.default,
                SearchWrapper: SearchWrapper_vue_1.default
            },
            metaInfo: function () {
                var title = this.$t("title." + this.$route.name);
                var metaInfo = {
                    title: this.$t('title.default'),
                    titleTemplate: '%s | ' + title,
                    meta: [
                        { name: 'og:title', content: title },
                        { name: 'og:url', content: window.location.href }
                    ],
                    link: [
                        { rel: 'canonical', href: window.location.href }
                    ]
                };
                return metaInfo;
            }
        })
    ], SearchPilgrimTrips);
    return SearchPilgrimTrips;
}(BaseView_1.BaseView));
exports.default = SearchPilgrimTrips;
